module.exports = __webpack_public_path__ + "img/code.7c7cb078.png";